<script setup lang="tsx">
import HeaderComponent from '../shared/HeaderComponent.vue'
import DocumentFolders from './DocumentFolders.vue'
</script>

<template>
	<HeaderComponent :title="$t('document.label', 2)">
		<template #right-side> </template>
	</HeaderComponent>
	<DocumentFolders :show-history="true"></DocumentFolders>
</template>

<style lang="sass" scoped></style>
